// extracted by mini-css-extract-plugin
module.exports = {"success":"StudentAnalyticsReviewModal_success__2jMY7","failed":"StudentAnalyticsReviewModal_failed__2TgYh"};